import React, { MouseEvent, useState } from "react"
import { useParams } from "react-router-dom";

import {
  useLayerPopupContext,
  useSchedule
} from "@shared/contexts"
import { kick } from "@shared/modules"
import { Params } from "@shared/types"

const LiveEndVod = () => {
  const { scheduleId, streamerName } = useParams<Params>()

  const { close } = useLayerPopupContext()
  const { schedule } = useSchedule()

  const isScheduleEnd = schedule?.scheduleStatus === "END"
  const streamerUsername = schedule?.user.username
  const streamerNickname = schedule?.user.nickname
  const isAllSchedule = schedule?.paymentInformation === "ALL"

  return (
    <React.Fragment>
      <article
        className="popup"
        style={{ width: "540px", margin: "-155px 0 0 -270px" }}
      >
        <div className="titB">
          <h1>방송종료</h1>
          <a
            href="#!"
            onClick={(e: MouseEvent) => {
              e.preventDefault()

              if (schedule && isScheduleEnd) {
                kick()
                return
              }

              close()
            }}
            title="닫기"
          >
            닫기
          </a>
        </div>
        <div className="txtB">
          <div className="roundB txt">
            <p>{`${streamerNickname}의 라이브 방송이 종료되었습니다.\n최근 녹화 방송을 시청하시겠습니까?`}</p>
          </div>
        </div>
        <div className="btnB">
          <a
            href="#!"
            onClick={(e: MouseEvent) => {
              e.preventDefault()
              kick()
            }}
            className="cancel"
            title="닫기"
          >
            닫기
          </a>
          <a
            href="#!"
            onClick={(e: MouseEvent) => {
              e.preventDefault()
              
              let url: string
              if (isAllSchedule) {
                if (process.env.NODE_ENV === "development") {
                  url = `https://wownet-player.fnup.com/${streamerName}/${scheduleId}/vods`
                } else {
                  url = `/${streamerName}/${scheduleId}/vods`
                }
              } else {
                url = `https://www.wownet.co.kr/Futurewiz/BcastTool/Link/?type=HOME_VOD&analid=${streamerUsername}`
              }

              window.open(url, "_blank")
            }}
            className="btn"
            title="시청하기"
          >
            시청하기
          </a>
        </div>
      </article>
    </React.Fragment>
  )
}

export default LiveEndVod
